export default "__VITE_ASSET__CsXc$33L__"